import { useOidc } from "@iso/helpers/oidc";
import { Redirect } from "react-router-dom";

function Auth() {
   const { isAuthenticated } = useOidc();

   if (!isAuthenticated) {
      return (
         <Redirect
            to={{
               pathname: "/login",
            }}
         />
      );
   }

   return (
      <Redirect
         to={{
            pathname: "/choose-system",
         }}
      />
   );
}

export default Auth;
